import { apiDelete } from "./client";
import { useApiMutation } from "./queryHooks";

export default async function DeleteAPI(params,route) {
    return apiDelete(route, params);
}

export function useDeleteMutation(route, options = {}) {
    return useApiMutation({
        route,
        request: apiDelete,
        mutationKeyPrefix: "DELETE",
        options,
    });
}
